
import { Vue, Component, Prop } from 'vue-property-decorator';
import AlertBox from '../../core/components/Generics/AlertBox.vue';

@Component({
  components: {
    AlertBox
  }
})
export default class WarningAlert extends Vue {
 message: string = 'Esta acción generará una sobrescritura en el Mapa principal';
}
